module.exports = __webpack_public_path__ + "static/media/remove-user-vector.5fac1edc.svg";